import { CircularProgress } from '@mui/material';
import React from 'react';

const Waiting = () => {
    return (
        <div className="fixed top-0 left-0 w-full h-screen
        flex flex-col justify-center items-center bg-color">
            <CircularProgress size={50} />
            <span className="text-primary mt-4 text-xl opacity-animation">
                صبر کنید...
            </span>
        </div>
    );
}

export default Waiting;
